export default "__VITE_ASSET__BWC1d_WO__"